import { memo } from "react";
import {
    Paper,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Chip,
} from "@material-ui/core";
import { DashboardTableProps } from "./Dashboard.Type";
import { getCellValue } from "./Dashboard.Helper";
import CustomTooltip from "../Common/CustomToolTip";
import ReactLoadingOverlay from "react-loading-overlay";
import ClipLoader from "react-spinners/ClipLoader";
import { getFileNameWithoutExtension } from "../../Utility/Utils";


const DashboardTable = memo(({ columns, rows, dataLoading, classes, onDownloadImage }: DashboardTableProps) => {
    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow className="bg-[#E5F5F6] text-nowrap">
                        {columns.map((column) => (
                            <TableCell key={column.key} className={`${classes.bold} ${classes.stickyHeader}`}>
                                {column.header}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {!dataLoading ? (
                        rows.length === 0 ? null : rows.map((row) => (
                            <TableRow key={row.visitId}>
                                {columns.map(column => {
                                    const value = getCellValue(row, column);
                                    const files = column.controlType === "image"
                                        ? String(value).split(",").map(f => f.trim()).filter(Boolean)
                                        : [];
                                    return (
                                        <TableCell key={column.key}>
                                            {column.controlType === "image" ? (
                                                <div className={classes.photoChipContainer}>
                                                    {files.map((file, index) => {
                                                        const fileNameWithoutExt = getFileNameWithoutExtension(file);
                                                        return (
                                                            <Chip
                                                                key={file}
                                                                className={classes.photoChip}
                                                                clickable
                                                                size="small"
                                                                label={
                                                                    <span className={classes.photoChipLabel}>
                                                                        {`GT/${fileNameWithoutExt}`}
                                                                    </span>
                                                                }
                                                                onClick={() => onDownloadImage(row.visitId, file)}
                                                            />
                                                        );
                                                    })}
                                                </div>
                                            ) : (
                                                <CustomTooltip>
                                                    {value}
                                                </CustomTooltip>
                                            )}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        ))
                    ) : (
                        <>
                            <ReactLoadingOverlay
                                classNamePrefix="growindigo_"
                                active={true}
                                spinner={<ClipLoader color="#27878E" />}
                                text={""}
                            >
                            </ReactLoadingOverlay>
                        </>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
});

export default DashboardTable;
